class DebounceTimer {
  constructor({ callback, debounceMs = 2000 } = { debounceMs: 2000 }) {
    this.debounceTimer;
    this.timerStopped = true;
    this.debounceMs = debounceMs;

    this.callback = () => {
      this.timerStopped = true;
      if (callback) callback();
    };
  }

  start() {
    this.timerStopped = false;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(this.callback, this.debounceMs);
  }

  isTimerRunning() {
    return this.timerStopped ? false : true;
  }
}

export default DebounceTimer;
